import React, {Component} from 'react';
import ReactDOM from "react-dom";
import IframeVideo from "../components/iframe-video";
import CTA from "../components/cta";

class Header extends Component {
    render() {
        return (
            <div>
                <div className="section-1-et">
                    <div className="container p-40">
                        <div className="row mb0 p-40">
                            <div className="col s12 center-align">
                                <h1 className="f-38 white-text bold-text text-uppercase">
                                    <span className="text-normal">Piloto 151 & </span>
                                    Disrupt
                                <span className="text-normal"> Present: <br/></span>
                                <span className="f-TO"><span className="white-text">DISRUPT PUERTO RICO</span></span></h1>
                            </div>
                            <div className="col s12 m12 l10 offset-l1 center-align">
                                <IframeVideo/>
                                <br/>
                                <a href="#tickets" className="btn-large cta-green orange waves-effect waves-light">RESERVE YOUR SPOT</a>
                                <br/>
                                <br/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )

    }

}

export default Header;



// WEBPACK FOOTER //
// ./src/components/header.js